<template>
  <div class="container my-4">
    <div class="component-header mb-4">
      <h1>Budynek</h1>
      <div class="ml-4 add-edit-actions">
        <button type="submit" form="building-details" class="action">
          <i class="fa fa-floppy-o" aria-hidden="true"></i>
        </button>
        <button data-toggle="modal" data-target="#building" class="action">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div
        class="saved-text"
        v-bind:class="[
          showMessage ? 'visible' : 'hidden',
          success ? 'text-success' : 'text-danger',
        ]"
      >
        {{ messageText }}
      </div>
    </div>
    <form id="building-details" @submit.prevent="save()">
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="title">Adres współczesny*</label>
          <input
            type="text"
            class="form-control"
            id="title"
            v-model="building.title"
            required
            maxlength="100"
          />
          <small class="form-text text-muted">Pole obowiązkowe</small>
        </div>
        <div class="form-group col-md-6">
          <label for="name">Nazwa</label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="building.name"
            maxlength="100"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="architekt-list">Arichtekt z listy</label>
          <select
            id="architekt-list"
            class="form-control"
            v-model="building.architectId"
          >
            <option
              v-for="person in people"
              v-bind:value="person.id"
              :key="person.id"
            >
              {{ person.lastName + " " + person.name }}
            </option>
          </select>
        </div>

        <div class="form-group col-md-6">
          <label for="architekt-text">Architekt tekst</label>
          <input
            type="text"
            class="form-control"
            id="architekt-text"
            v-model="building.architectName"
            maxlength="200"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="investor-list">Inwestor z listy</label>
          <select
            id="investor-list"
            class="form-control"
            v-model="building.builderId"
          >
            <option
              v-for="person in people"
              v-bind:value="person.id"
              :key="person.id"
            >
              {{ person.lastName + " " + person.name }}
            </option>
          </select>
        </div>

        <div class="form-group col-md-6">
          <label for="investor-text">Inwestor tekst</label>
          <input
            type="text"
            class="form-control"
            id="investor-text"
            v-model="building.builderName"
            maxlength="200"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="historicAddresses">Adresy historyczne*</label>
          <input
            type="text"
            class="form-control"
            id="historicAddresses"
            v-model="building.historicAddresses"
            maxlength="200"
            required
          />
          <small class="form-text text-muted">Pole obowiązkowe</small>
        </div>
      </div>
      <div class="form-row align-items-center">
            <div class="form-group col-md-6">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              id="notExists"
              v-model="building.notExists"
            />
            <label class="custom-control-label" for="notExists"
              >Obiekt nie istnieje</label>
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="constructionYear">Rok budowy*</label>
          <input
            type="text"
            class="form-control"
            id="constructionYear"
            v-model="building.constructionYear"
            maxlength="50"
            required
          />
          <small class="form-text text-muted">Pole obowiązkowe</small>
        </div>
    
      </div>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="libraryLink">Link do pełnej dokumentacji</label>
          <input
            type="url"
            class="form-control"
            id="libraryLink"
            v-model="building.libraryLink"
          />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <div class="form-group col-md-6">
            <label for="card-image">Główne zdjęcie</label>
            <div v-if="building.imageData">
              <img
                id="card-image"
                :src="building.imageData"
                width="200"
                height="200"
              />
              <button
                type="button"
                style="font-size: 20; margin-top: 20px; margin-left: 50px"
                class="btn btn-dark"
                aria-label="Usuń"
                @click="removeMainImage()"
              >
                <span aria-hidden="true">Usuń</span>
              </button>
            </div>
            <picture-input
              v-if="!building.imageData"
              ref="pictureInput"
              @change="onChange"
              id="picTest"
              style="z-index: 1; width: 200px; height: 200px"
              margin="16"
              accept="image/jpeg,image/png"
            >
            </picture-input>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="longitude">Długość</label>
          <input
            type="text"
            class="form-control"
            id="longitude"
            v-model="building.longitude"
            v-on:change="changeMarker(building.latitude, $event.target.value)"
          />
        </div>
        <div class="form-group col-md-6">
          <label for="latitude">Szerokość</label>
          <input
            type="text"
            class="form-control"
            id="latitude"
            v-model="building.latitude"
            v-on:change="changeMarker($event.target.value, building.longitude)"
          />
        </div>
      </div>

      <div class="form-group">
        <label for="map">Mapa</label>
        <CityMap
          id="map"
          @selected="changeCoordinates($event)"
          :coordinates="coordinates"
        />
      </div>
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="ownersPL">Właściciele w języku polskim</label>
          <div>
            <vue-editor
              id="ownersPL"
              v-model="building.ownersPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="ownersDE">Właściciele w języku niemieckim</label>
          <div>
            <vue-editor
              id="ownersDE"
              v-model="building.ownersDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="contentPL">Opis w języku polskim</label>
          <div>
            <vue-editor
              id="contentPL"
              v-model="building.contentPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="contentDE">Opis w języku niemieckim</label>
          <div>
            <vue-editor
              v-model="building.contentDE"
              id="contentDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="earlierLaterBuildingsPL"
            >Wcześniejsze/późniejsze zabudowania w języku polskim</label
          >
          <div>
            <vue-editor
              id="earlierLaterBuildingsPL"
              v-model="building.earlierLaterBuildingsPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="earlierLaterBuildingsDE"
            >Wcześniejsze/późniejsze zabudowania w języku niemieckim</label
          >
          <div>
            <vue-editor
              v-model="building.earlierLaterBuildingsDE"
              id="earlierLaterBuildingsDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="reconstructionsPL"
            >Przebudowy/instalacje w języku polskim</label
          >
          <div>
            <vue-editor
              id="reconstructionsPL"
              v-model="building.reconstructionsPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="reconstructionsADE"
            >Przebudowy/instalacje w języku niemieckim</label
          >
          <div>
            <vue-editor
              v-model="building.reconstructionsDE"
              id="reconstructionsDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="shopsPL">Geszefty w języku polskim</label>
          <div>
            <vue-editor
              id="shopsPL"
              v-model="building.shopsPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="shopsDE">Geszefty w języku niemieckim</label>
          <div>
            <vue-editor
              id="shopsDE"
              v-model="building.shopsDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="citizensPL">Mieszkańcy w języku polskim</label>
          <div>
            <vue-editor
              id="citizensPL"
              v-model="building.citizensPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <div class="form-group col-md-6">
          <label for="citizensDE">Mieszkańcy w języku niemieckim</label>
          <div>
            <vue-editor
              v-model="building.citizensDE"
              id="citizensDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="archivesPL">Bibliografia, archiwalia, odnośniki</label>

          <div>
            <vue-editor
              id="archivesPL"
              v-model="building.archivesPL"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div>
        <!-- <div class="form-group col-md-6">
          <label for="archivesDE"
            >Bibliografia, archiwalia, odnośniki w języku niemieckim</label
          >
          <div>
            <vue-editor
              v-model="building.archivesDE"
              id="archivesDE"
              :editor-toolbar="$settings.editorToolbar"
            />
          </div>
        </div> -->
      </div>

      <div class="form-group" v-bind:class="[id ? 'visible' : 'hidden']">
        <button @click="editImages" type="button" class="btn btn-primary btn-lg btn-block">
          Zdjęcia
        </button>
      </div>
    </form>
    <Modal v-bind:settings="modalSettings" @confirm="goBack()" />
    <Loader v-if="showLoader" />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import Modal from "./Modal";
import CityMap from "./CityMap";
import FileReader from "vue-filereader";
import BuildingImage from "./Image";
import PictureInput from "vue-picture-input";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import Loader from "./Loader";

export default {
  components: {
    VueEditor,
    Modal,
    CityMap,
    PictureInput,
    Loader,
  },
  props: ["list"],
  data() {
    return {
      building: {
        latitude: null,
        longitude: null,
        images: [],
        imageData: null,
      },
      coordinates: {
        lat: null,
        lng: null,
      },
      modalSettings: {
        body: "Czy na pewno chcesz wyjść? Niezapisane zmiany zostaną utracone.",
        modalId: "building",
      },
      messageText: "",
      showMessage: false,
      people: [],
      controlImages: [],
      id: null,
      success: false,
      showLoader: false,
    };
  },
  methods: {
    initialize: function () {
      this.id = this.$route.params.id;
      this.$api.getPeople().then((data) => {
        this.people = data;
        this.people.unshift({ id: null, lastName: "Wybierz...", name: "" });
        if (this.id) {
          this.$api.getBuildingDetailsById(this.id).then((data) => {
            this.building = data;
            this.coordinates = {};
            this.coordinates.lat = this.building.latitude;
            this.coordinates.lng = this.building.longitude;
          });
        }
      });
    },
    editImages: function () {
      this.$router.push({
        name: "BuildingImagesEdit",
        params: { id: this.id },
      });
    },
    changeCoordinates(e) {
      this.building.latitude = e.lat;
      this.building.longitude = e.lng;
    },
    changeMarker(latitude, longitude) {
      this.coordinates = { lat: latitude, lng: longitude };
    },
    addImage: function () {
      let maxId =
        this.building.images && this.building.images.length
          ? this.building.images.reduce(
              (max, image) => (image.id > max ? image.id : max),
              this.building.images[0].id
            )
          : 0;
      let image = {
        descriptionPL: "",
        descriptionDE: "",
        id: maxId + 1,
        name: "",
        imageData: null,
      };
      this.building.images.push(image);
      return image;
    },
    uploadImageSuccess(formData, index, fileList) {
      let image = this.addImage();
      image.imageData = fileList[index].path;
      image.name = fileList[index].name;
      if (index === fileList.length - 1) {
        this.controlImages.splice(0);
      }
    },
    removeImage(image) {
      var index = this.building.images.indexOf(image);
      if (index > -1) {
        this.building.images.splice(index, 1);
      }
    },
    removeMainImage() {
      this.building.imageData = null;
    },
    save: function () {
      this.clearMessage();
      if (this.building.latitude) {
        this.building.latitude = Number(this.building.latitude);
      }
      if (!this.building.latitude) {
        this.building.latitude = null;
      }
      if (this.building.longitude) {
        this.building.longitude = Number(this.building.longitude);
      }
      if (!this.building.longitude) {
        this.building.longitude = null;
      }

      let slug = this.getSlug(this.building.title);
      if (this.list && this.list.length) {
        var buildingExists = this.list
          .filter((b) => b.id != this.id)
          .some((b) => b.slug == slug);
        if (buildingExists) {
          this.displayNonUniqueValue();
          return;
        }
      }
      this.building.slug = slug;
      if (this.id) {
        this.update(this.building);
      } else {
        this.create(this.building);
      }
    },
    update: function (data) {
      this.$api.updateBuilding(data).then((response) => {
        if (response.ok) {
          this.displaySucess();
        } else {
          this.displayFailure();
        }
      });
    },
    createBase64Image(fileObject) {
      const reader = new window.FileReader();
      let self = this;
      reader.onloadend = function (event) {
        try {
          let res = event.target.result;
          self.building.imageData = res;
        } catch (err) {
          alert("Error: " + err);
        }
      };
      reader.readAsDataURL(fileObject);
    },
    onChange() {
      console.log("Picture changed!");
      if (this.$refs.pictureInput.file) {
        this.createBase64Image(this.$refs.pictureInput.file);
      } else {
        console.log("Old browser. No support for Filereader API");
      }
    },
    create: function (data) {
      data.test = this.image64;

      this.$api.createBuilding(data).then((data) => {
        if (data.ok) {
          this.displaySucess();
          this.goBack();
        } else {
          this.displayFailure();
        }
      });
    },
    getSlug(title) {
      let slug = "";
      if (title) {
        slug = this.$localization
          .normalizeString(title.toLowerCase())
          .trim()
          .replace(/\s/g, "")
          .replace(/[&/\\#,+()$~%.'":*?<>{}]/g, "-");
      }
      return slug;
    },
    displaySucess: function () {
      this.messageText = "Dane zostały pomyślnie zapisane";
      this.showMessage = true;
      this.success = true;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayFailure: function () {
      this.messageText = "Wystąpił błąd w zapisie danych";
      this.showMessage = true;
      this.success = false;
      setTimeout(() => (this.showMessage = false), 3000);
    },
    displayNonUniqueValue: function () {
      this.messageText =
        "Nie można zapisać obiektu. Adres współczesny już istnieje.";
      this.showMessage = true;
      this.success = false;
    },
    clearMessage() {
      this.messageText = "";
      this.showMessage = false;
    },
    goBack() {
      this.$router.push({ name: "Building" });
    },
    goBackWithSave() {
      this.save();
      this.goBack();
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteUpdate(to, from, next) {
    this.initialize();
    next();
  },
};
</script>

<style>
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>